"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
function onChange() {}
var Demo = function Demo() {
  var _theme$useToken = _antd.theme.useToken(),
    token = _theme$useToken.token;
  return /*#__PURE__*/_react.default.createElement(_antd.Input, {
    defaultValue: "I'm the content",
    suffix: /*#__PURE__*/_react.default.createElement(_icons.CheckCircleFilled, {
      style: {
        color: token.colorSuccess
      }
    }),
    onChange: onChange
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorSuccess'],
  key: 'warning'
};
var _default = exports.default = componentDemo;